/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var TWF = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // Menu toggle
        menuToggle();

        // Show images
        showImages();

        // Subscribe forms
        subscribeFormHome();
        subscribeFormFooter();
        subscribeFormSidebar();

        // Fire up Flexslider slideshow
        slideshow();
        slideshow_thumbs();

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired


      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        // Beam me up Scottie (well to top of the page anyway)
        pageScroll();

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = TWF;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


/* ==========================================================================
   Toggle main menu
   ========================================================================== */

function menuToggle(){
  $(document).on("click", ".js-menu", function(event) {
      $(".menu-sidebar").toggleClass('js-nav-show');
      $(".wrapper").each( function(){
        $(this).toggleClass('js-nav-toggle');
      });
      event.preventDefault();
  });
}


/* ==========================================================================
   Scroll to top
   ========================================================================== */

function pageScroll(){
    $('html, body').animate({ scrollTop: 0 }, 123);
}



/* ==========================================================================
  Fire up Flexslider slideshow
   ========================================================================== */

function slideshow() {
    
  // Fire up flexslider
  $('.home-slider').flexslider({
    controlNav: false,
    directionNav: true,
    slideshow: false,
    useCSS: true,
    prevText: "",
    nextText: "",
    pauseOnAction: true,
    pauseOnHover: true,
    touch: true,
    keyboard: true,
    slideshowSpeed: 4000,
    animationSpeed: 234,
    initDelay: 0,
    start: function(){
      showImages();
    }
  });

}


/* ==========================================================================
  Fire up Flexslider slideshow with thumbs
   ========================================================================== */

function slideshow_thumbs() {
    
  // // Fire up flexslider + sync

  $('.slideshow__thumbs').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    //itemWidth: 100,
    itemMargin: 5,
    minItems: 3,
    maxItems: 3,
    asNavFor: '.slideshow__slides'
  });
 
  $('.slideshow__slides').flexslider({
    prevText: "",
    nextText: "",
    touch: true,
    keyboard: true,
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    sync: ".slideshow__thumbs",
    start: function(){
      showImages();
    }
  });
      
}


/* ==========================================================================
   Fire up unveil lazyload plugin with bonus retina image loader
   ========================================================================== */

function showImages(){
    // Sizzle up some images
    var images = $("img.unveil");
    
    // Let's see 'em
    images.unveil(0, function() {
        $(this).load(function() {
            this.style.opacity = 1;
        });
    });
    
    // Edge case, browser window transferred to retina screen
    $(window).resize(_.debounce(function(){
        images.unveil();
    }, 500));
}



/* ==========================================================================
   Prevent default action on anchor elements will .null classname
   ========================================================================== */

$(document).on("click", "#site .js-null", function(event) {
    event.preventDefault();
});



/* ==========================================================================
   Subscribe form
   ========================================================================== */

// Initialise forms
function subscribeFormHome(){

  var form = $('.home-subscribe-form');
  var inputs = $('.home-subscribe-form input');
  var thanks = $('.home-subscribe-thanks');
  var error = $('.home-subscribe-error');

  processForm( thanks , error , form , inputs );
}

function subscribeFormFooter(){

  var form = $('.footer-subscribe-form');
  var inputs = $('.footer-subscribe-form input');
  var thanks = $('.footer-subscribe-thanks');
  var error = $('.footer-subscribe-error');

  processForm( thanks , error , form , inputs );
}

function subscribeFormSidebar(){

  var form = $('.menu-subscribe-form');
  var inputs = $('.menu-subscribe-form input');
  var thanks = $('.menu-subscribe-thanks');
  var error = $('.menu-subscribe-error');

  processForm( thanks , error , form , inputs );
}

// Process form
function processForm( thanks , error , form , inputs ){

    // Validate form polyfill
    form.h5Validate({
    errorClass:'error'
    });

    // Bind the submit event to the form
    form.submit(function(event){ 

      // Stop the form from submitting
      event.preventDefault();

      // Set valid boolean
      var valid = true;

      // Check for validation errors
      inputs.each(function() {
        if( $(this).hasClass('error') ){
          valid = false;
        }
      });

      // Submit form
      if ( valid === true ) {

      // Get the form data
      var data = $(this).serialize();

      // Send data and get response
      processsData( thanks , error , data , form , inputs );

    }

  });

}

// Send form data to PHP processor function getQuery() in ajax.php
function processsData( thanks , error , data , form , inputs ) {

    $.ajax({

        type : 'POST',
        url : TWFAjax.ajaxurl,
        data : {
            action : 'get_query',
            data : data,
            QueryNonce : TWFAjax.TWFNonce
        },
        beforeSend : function(){
        }, 
        success:function (response) {

            //$('#response').html(response);
            form.fadeOut('slow',function(){
                    thanks.fadeIn().delay(876).fadeOut('slow',function(){
                        inputs.val('');
                        inputs.blur();
                        form.find('div.error').hide();
                        form.fadeIn();
                    });
            });

        },
        error:function () {

            form.fadeOut('slow',function(){
                    error.fadeIn().delay(876).fadeOut('slow',function(){
                        inputs.val('');
                        inputs.blur();
                        form.find('div.error').hide();
                        form.fadeIn();
                    });
            });

        }
    });
}



})(jQuery); // Fully reference jQuery after this point.
